import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import FieldType from "@mapmycustomers/shared/enum/fieldModel/FieldType";
import FilterOperator from "@mapmycustomers/shared/enum/FilterOperator";

import { listFormatter } from "@app/util/fieldModel/impl/fieldUtil";
import EmptyFilter from "@app/util/filters/EmptyFilter";
import GroupsFilter, { GROUPS_FILTER_OPERATORS } from "@app/util/filters/GroupsFilter";

import Field, { FieldProperties } from "./Field";

class GroupsField extends Field {
  constructor(data: Omit<FieldProperties, "type">) {
    super({
      csvExportProperties: {
        valueFormatter: listFormatter("name", ";"),
      },
      customFilterConfig: {
        defaultInstance: "groups",
        disallowedConjunctions: ["OR", "NOT"],
        filterInstances: {
          empty: EmptyFilter,
          groups: GroupsFilter,
        },
        oneOccurrenceOnly: true,
        operators: [
          ...GROUPS_FILTER_OPERATORS,
          { instance: "empty", operator: FilterOperator.EMPTY },
        ],
        topLevelOnly: true,
      },
      customGridProperties: {
        cellRenderer: "groupsCellRenderer",
      },
      extraPlatformFiltersGetter: () => ({ includeGroups: true }),
      features: [
        FieldFeature.GROUP_FIELD,
        FieldFeature.FILTERABLE,
        FieldFeature.FILTERABLE_ON_MAP,
        FieldFeature.SUPPORTS_SET_FILTER,
        FieldFeature.VISIBLE_BY_DEFAULT,
        FieldFeature.NON_INTEGRATION,
        FieldFeature.DATA_VIEW,
        FieldFeature.RELATIONSHIPS_CATEGORY,
        FieldFeature.HISTORY_FIELD,
      ],
      type: FieldType.LIST,
      valueFormatter: listFormatter("name"),
      ...data,
    });
  }

  get isDefaultValueAllowed() {
    return true;
  }
}

export default GroupsField;
